import { render, staticRenderFns } from "./EditDetailsModal.vue?vue&type=template&id=bf8bad86&scoped=true&"
import script from "./EditDetailsModal.vue?vue&type=script&lang=js&"
export * from "./EditDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditDetailsModal.vue?vue&type=style&index=0&id=bf8bad86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8bad86",
  null
  
)

export default component.exports